var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.07 6.12035C21.2313 7.28195 21.2429 9.16203 20.0964 10.3383L10.8635 19.8119C10.1109 20.584 9.07842 21.0192 8.0007 21.0192L5.24927 21.0188C3.82788 21.0188 2.69248 19.8339 2.75226 18.4127L2.86992 15.6039C2.91207 14.6023 3.3288 13.653 4.03685 12.9439L13.3368 3.62982C14.5075 2.45736 16.4063 2.45664 17.5779 3.62821L20.07 6.12035ZM5.45107 14.3581C5.09706 14.7127 4.88937 15.1873 4.86829 15.6881L4.74925 18.4969C4.7373 18.781 4.96448 19.018 5.24851 19.0183L8.00132 19.0186C8.54001 19.0186 9.0558 18.8008 9.43202 18.415L15.7928 11.8894L11.8515 7.94801L5.45107 14.3581ZM13.2646 6.53272L17.1889 10.4571L18.6657 8.94209C19.0478 8.55005 19.0438 7.92285 18.6569 7.53563L16.1647 5.04349C15.7742 4.65297 15.1413 4.65321 14.751 5.04403L13.2646 6.53272ZM13.3934 19.9456C13.3934 20.4981 13.8409 20.9459 14.393 20.9459H20.5147C21.0668 20.9459 21.5143 20.4981 21.5143 19.9456C21.5143 19.3931 21.0668 18.9452 20.5147 18.9452H14.393C13.8409 18.9452 13.3934 19.3931 13.3934 19.9456Z",
    fill: "#726C6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.44c84afbc1c066e955323588df220ee5.svg";
export { ForwardRef as ReactComponent };